(function () {
  function initGallery(gallery) {
    if (gallery.dataset.ldInit) return;
    gallery.dataset.ldInit = '1';

    var track = gallery.querySelector('.ld-gallery__track');
    if (!track) return;

    var slides = track.children;
    var dotsWrap = gallery.querySelector('.ld-gallery__dots');
    var previous = gallery.querySelector('.ld-gallery__nav--prev');
    var next = gallery.querySelector('.ld-gallery__nav--next');

    if (slides.length <= 1) {
      if (previous) previous.style.display = 'none';
      if (next) next.style.display = 'none';
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var index = 0; index < slides.length; index += 1) {
        (function (slideIndex) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ld-gallery__dot' + (slideIndex === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Image ' + (slideIndex + 1));
          dot.addEventListener('click', function () {
            track.scrollTo({ left: slideIndex * track.clientWidth, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        })(index);
      }
    }

    function updateDots() {
      var activeIndex = Math.round(track.scrollLeft / track.clientWidth);
      if (!dotsWrap) return;
      var dots = dotsWrap.children;
      for (var index = 0; index < dots.length; index += 1) {
        dots[index].classList.toggle('is-active', index === activeIndex);
      }
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateDots);
    });
    if (previous) {
      previous.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
    }
  }

  function initAll() {
    var galleries = document.querySelectorAll('.ld-gallery');
    for (var index = 0; index < galleries.length; index += 1) {
      initGallery(galleries[index]);
    }
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  if (!window.__ldGalleryObserver) {
    window.__ldGalleryObserver = new MutationObserver(initAll);
    var root = document.querySelector('.product-sec') || document.body;
    window.__ldGalleryObserver.observe(root, { childList: true, subtree: true });
  }
})();
